import React from 'react';
import MobileDetect from 'mobile-detect';

import { i18n } from 'core/i18n';
const { formatText } = i18n;

const ErrorModal = ({ onAccept }) => {
    const md = new MobileDetect(navigator.userAgent);

    return (
        <div className="videoScreen-container">
            <br />
            <div className="row" style={{ height: '50px' }}>
                <div className="col-md-1 col-xs-1">
                    <span
                        className="icons icons--icon-warning"
                        style={{
                            ...(md.phone() && {
                                height: '25px',
                                width: '25px',
                                marginTop: '10px',
                            }),
                        }}
                    />
                </div>
                <div className="col-md-10 col-xs-10" style={{ height: '50px' }}>
                    <h3 className="font-heading3" style={{ lineHeight: '50px', paddingLeft: '20px' }}>
                        {formatText('identity-videoCallErrorTitle')}
                    </h3>
                </div>
            </div>
            <ul>
                <li className="video-screen__modal-body-text font-paragraph2 modal-bullets">
                    {' '}
                    {formatText('identity-videoCallBadConnection')}
                </li>
                <li className="video-screen__modal-body-text font-paragraph2 modal-bullets">
                    {' '}
                    {formatText('identity-videoCallDocumentExpired')}
                </li>
                <li className="video-screen__modal-body-text font-paragraph2 modal-bullets">
                    {' '}
                    {formatText('identity-videoCallInvalidCredentials')}
                </li>
            </ul>

            <p className="video-screen__modal-body-text font-paragraph2">
                {formatText('identity-videoCallConfirmCredentials')}
            </p>
            <div className="video-screen__modal-buttons">
                <button className="form__button form__button-secondary error_button" onClick={onAccept}>
                    {formatText('button-understood')}
                </button>
            </div>
        </div>
    );
};

export default ErrorModal;
